import { createAction, props } from '@ngrx/store';
import type { Answer } from '@front-end/ngx-interview';
import type {
  calculateScoresFromAnswers,
  QuestionnaireOfferValues,
  QuestionnaireResultsContent,
  QuestionnaireStep,
  RetentionQuestionnaireModel,
} from '@retention/shared';

export const startQuestionnaire = createAction(
  '[RetentionQuestionnaire] Start Questionnaire',
  props<{ url?: string }>()
);

export const setActiveStep = createAction(
  '[RetentionQuestionnaire] Set Active Step',
  props<{ step: QuestionnaireStep }>()
);

export const exitQuestionnaireFlow = createAction(
  '[RetentionQuestionnaire] Exit Questionnaire Flow',
  props<ReturnType<typeof calculateScoresFromAnswers> & { answers: Answer[] }>()
);

export const finishQuestionnaire = createAction(
  '[RetentionQuestionnaire] Finish Questionnaire'
);

export const clearQuestionnaireState = createAction(
  '[RetentionQuestionnaire] Clear Questionnaire State'
);

export const closeQuestionnaire = createAction(
  '[RetentionQuestionnaire] Close Questionnaire',
  props<{ payload: RetentionQuestionnaireModel; currentStep?: number }>()
);

export const openExplanationModal = createAction(
  '[RetentionQuestionnaire] Open Explanation Modal',
  props<{
    content: QuestionnaireResultsContent;
    currentChoice?: QuestionnaireOfferValues;
    highestMatch?: QuestionnaireOfferValues;
    answers?: Answer[];
    offerDurationTitle?: string;
    offerProductTitle?: string;
    selectOffer: () => void;
  }>()
);

export const chooseVariableContract = createAction(
  '[RetentionQuestionnaire] Choose Variable Contract',
  props<{ content: QuestionnaireResultsContent }>()
);
